import { getIdToken as getIdTokenCore } from '@bounded-sh/core';
// Wrapper for getIdToken - passes isServer=false for client-side usage
export async function getIdToken() {
    return getIdTokenCore(false);
}
